export default __webpack_public_path__ + "static/media/invoice.dcbdc8f9.png";